import React from "react";
import "./Dropzone.scss";
import loadImg from "./assets/unloading-truck.png";
import { useTranslation } from "react-i18next";

export const UnloadTruck = () => {
  const { t } = useTranslation("common");

  return (
    <div className={"dropzone"}>
      <img src={loadImg} alt="load truck" height={150} />
      <p>{t("Remove item from truck")}</p>
    </div>
  );
};
